import { simpleAlert } from "components/CommonLib/CommonLib";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DetailModal from "./DetailModal";

const EstimateCard = ({ item, onAddToCart, isAdmin, onEditItem, onDeleteItem }) => {
  const storesDispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const [isCartHovered, setIsCartHovered] = useState(false);
  const [isDetailHovered, setIsDetailHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <DetailModal item={item} onClose={() => setIsModalOpen(false)} onAddToCart={onAddToCart} />
      )}

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          overflow: "hidden",
          cursor: "pointer",
          transition: "all 0.3s ease",
          transform: isHovered ? "translateY(-3px)" : "translateY(0)",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* 이미지 영역 */}
        <div
          style={{
            width: "100%",
            aspectRatio: "1 / 1",
            backgroundColor: "#f5f5f5",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={item.image || "/placeholder.jpg"}
            alt={item.name}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
          {isAdmin && isHovered && (
            <div
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                display: "flex",
                gap: "4px",
                zIndex: 5,
              }}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onEditItem(item);
                }}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                수정
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  simpleAlert(
                    storesDispatch,
                    "알림",
                    `${item.name} 을(를) 삭제하시겠습니까?`,
                    false,
                    undefined,
                    () => {
                      onDeleteItem(item);
                    },
                  );
                }}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#e53935",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                삭제
              </button>
            </div>
          )}
          {/* 호버 오버레이 */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.55)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.3s ease",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px",
            }}
          >
            {/* 기구 이름 */}
            <div
              style={{
                color: "white",
                fontSize: "16px",
                fontWeight: "700",
                textAlign: "center",
                textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                marginTop: "8px",
              }}
            >
              {item.name}
            </div>

            {/* 버튼 영역 */}
            <div style={{ display: "flex", gap: "8px", width: "100%" }}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                }}
                onMouseEnter={() => setIsDetailHovered(true)}
                onMouseLeave={() => setIsDetailHovered(false)}
                style={{
                  flex: 1,
                  padding: "8px 0",
                  backgroundColor: isDetailHovered ? "#f0f0f0" : "white",
                  color: "#032063",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transform: isDetailHovered ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.15s ease",
                }}
              >
                자세히 보기
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onAddToCart(item);
                }}
                onMouseEnter={() => setIsCartHovered(true)}
                onMouseLeave={() => setIsCartHovered(false)}
                style={{
                  flex: 1,
                  padding: "8px 0",
                  backgroundColor: isCartHovered ? "#1565c0" : "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transform: isCartHovered ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.15s ease",
                }}
              >
                카트에 담기
              </button>
            </div>
          </div>
        </div>

        {/* 내용 영역 */}
        <div style={{ padding: "20px 12px" }}>
          <h3 style={{ margin: "0 0 12px 0", fontSize: "16px" }}>{item.name}</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px" }}>
            <span
              style={{
                padding: "4px 12px",
                backgroundColor: "#e3f2fd",
                borderRadius: "16px",
                fontSize: "12px",
              }}
            >
              {item.model}
            </span>
            <span
              style={{
                padding: "4px 12px",
                backgroundColor: "#f0f0f0",
                borderRadius: "16px",
                fontSize: "12px",
              }}
            >
              {item.series}
            </span>

            <span
              style={{
                padding: "4px 12px",
                backgroundColor: "#f3e5f5",
                borderRadius: "16px",
                fontSize: "12px",
              }}
            >
              {item.format}
            </span>
          </div>
          {/* 가격 */}
          {item.price !== null && (
            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#032063",
                textAlign: "right",
              }}
            >
              {item.price > 0 ? `${item.price.toLocaleString()}원` : "가격 문의"}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EstimateCard;
